/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Coinvestments_Filters_Allregions2Inputs */

const en_coinvestments_filters_allregions2 = /** @type {(inputs: Coinvestments_Filters_Allregions2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`All regions`)
};

/**
* | output |
* | --- |
* | "All regions" |
*
* @param {Coinvestments_Filters_Allregions2Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const coinvestments_filters_allregions2 = /** @type {((inputs?: Coinvestments_Filters_Allregions2Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coinvestments_Filters_Allregions2Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_coinvestments_filters_allregions2(inputs)
});
export { coinvestments_filters_allregions2 as "coInvestments_filters_allRegions" }